"use client";
import { useEffect, useState } from "react";
import "./styles.scss";
import api from "../../services/api";
import { useParams } from "react-router-dom";

export default function ImportProgress({showLabel, status, isAssociated}) {
  const [current, setCurrent] = useState(0);
  const [total, setTotal] = useState(0);
  const [situation, setSituation] = useState('');
  const { id } = useParams();
  
  useEffect(() => {
    getProductsCount(id);

    if (status === "connecting" && isAssociated) {
      const intervalId = setInterval(() => {
        getProductsCount(id);
      }, 3000);

      return () => clearInterval(intervalId);
    }
  }, [id, status, isAssociated]);

  useEffect(() => {
    if (situation === 'finished') {
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  }, [current, total, situation]);

  const getProductsCount = (id) => {
    api.get(`/supplier/batch/${id}`).then(res => {
      setCurrent(res.data.resource.processed);
      setTotal(res.data.resource.total);
      setSituation(res.data.resource.status);
    });
  };

  const percent = (current / total) * 100;

  return (
    <div className="import-progress">
        {showLabel && 
            <p className="import-progress__text">
                Conexão com o fornecedor em andamento...
            </p>
        }

      <div className="import-progress__bar">
        <div
          className={`import-progress__fill ${percent >= 100 ? "paused" : ""}`}
          style={{ width: `${percent}%` }}
        >
        </div>
      </div>

      <p className="import-progress__counter">
        {current > 0 ? `${current} de ${total} processos concluídos` : 'Pode levar alguns minutos...'}
      </p>
    </div>
  );
}